import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensNotificationsComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	@service('model-manager/notifications')
	declare mmNotificationsService: Service.ModelManager.Notifications;

	trackingOrigin = 'notifications';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.titleText = 'Stay on top of your performance, automatically.';
		this.descText =
			'Create alerts and schedule updates for key metrics, dashboards, and reports, so you always know where performance stands.';

		this.readMoreUrl = 'https://help.databox.com/overview-notifications';

		this.topImageLightUrl = '/images/placeholders/alerts.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/alerts.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-notifications.svg';

		this.mainActions = [
			{
				action: this.create,
				icon: 'Plus',
				text: 'New notification',
				isForCreating: true,
			},
		];

		this.arrowText = 'Click here to get started';

		this.trialFeatures = [BillingFeature.SHARING];
	}
}
